(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "./node_modules/@babel/runtime/helpers/arrayLikeToArray.js":
/*!*****************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/arrayLikeToArray.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/arrayWithHoles.js":
/*!***************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/arrayWithHoles.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js":
/*!*****************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/asyncToGenerator.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

module.exports = _asyncToGenerator;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/defineProperty.js":
/*!***************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/defineProperty.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/iterableToArrayLimit.js":
/*!*********************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/iterableToArrayLimit.js ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/nonIterableRest.js":
/*!****************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/nonIterableRest.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/slicedToArray.js":
/*!**************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/slicedToArray.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(/*! ./arrayWithHoles.js */ "./node_modules/@babel/runtime/helpers/arrayWithHoles.js");

var iterableToArrayLimit = __webpack_require__(/*! ./iterableToArrayLimit.js */ "./node_modules/@babel/runtime/helpers/iterableToArrayLimit.js");

var unsupportedIterableToArray = __webpack_require__(/*! ./unsupportedIterableToArray.js */ "./node_modules/@babel/runtime/helpers/unsupportedIterableToArray.js");

var nonIterableRest = __webpack_require__(/*! ./nonIterableRest.js */ "./node_modules/@babel/runtime/helpers/nonIterableRest.js");

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/typeof.js":
/*!*******************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/typeof.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  }

  return _typeof(obj);
}

module.exports = _typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/unsupportedIterableToArray.js":
/*!***************************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/unsupportedIterableToArray.js ***!
  \***************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(/*! ./arrayLikeToArray.js */ "./node_modules/@babel/runtime/helpers/arrayLikeToArray.js");

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./node_modules/@babel/runtime/regenerator/index.js":
/*!**********************************************************!*\
  !*** ./node_modules/@babel/runtime/regenerator/index.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! regenerator-runtime */ "./node_modules/regenerator-runtime/runtime.js");


/***/ }),

/***/ "./node_modules/regenerator-runtime/runtime.js":
/*!*****************************************************!*\
  !*** ./node_modules/regenerator-runtime/runtime.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : undefined
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),

/***/ "./node_modules/webpack/buildin/global.js":
/*!***********************************!*\
  !*** (webpack)/buildin/global.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "./src/index.js":
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/*! exports provided: TemplateAnnotations, EditorContextHelper, LoggerService, PersonalizationService, PageEditorBridge */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./service */ "./src/service/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TemplateAnnotations", function() { return _service__WEBPACK_IMPORTED_MODULE_0__["TemplateAnnotations"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EditorContextHelper", function() { return _service__WEBPACK_IMPORTED_MODULE_0__["EditorContextHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LoggerService", function() { return _service__WEBPACK_IMPORTED_MODULE_0__["LoggerService"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PersonalizationService", function() { return _service__WEBPACK_IMPORTED_MODULE_0__["PersonalizationService"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PageEditorBridge", function() { return _service__WEBPACK_IMPORTED_MODULE_0__["PageEditorBridge"]; });



/***/ }),

/***/ "./src/service/EditorContextHelper.js":
/*!********************************************!*\
  !*** ./src/service/EditorContextHelper.js ***!
  \********************************************/
/*! exports provided: isSameOrigin, inIframe, inPreviewAsVisitor, inEditor, inEditorAsync, inEditorPreview, isRenderingAnnotation, refresh, onFrameReady, setServerUrl, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isSameOrigin", function() { return isSameOrigin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inIframe", function() { return inIframe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inPreviewAsVisitor", function() { return inPreviewAsVisitor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inEditor", function() { return inEditor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inEditorAsync", function() { return inEditorAsync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inEditorPreview", function() { return inEditorPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isRenderingAnnotation", function() { return isRenderingAnnotation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "refresh", function() { return refresh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onFrameReady", function() { return onFrameReady; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setServerUrl", function() { return setServerUrl; });
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__);



var isSameOrigin = function isSameOrigin() {
  try {
    var href = window.parent.location.href;
    return href != null;
  } catch (error) {
    return false;
  }
};

function getWindowInstance() {
  if (typeof window === 'undefined') {
    return undefined;
  }

  return isSameOrigin() ? window.parent : window;
}

var context = {
  serverUrl: isSameOrigin() && typeof window !== 'undefined' ? getWindowInstance().location.href : ''
};

var sleep = function sleep(ms) {
  return new Promise(function (r) {
    return setTimeout(r, ms);
  });
};

var waitFor = /*#__PURE__*/function () {
  var _ref = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.mark(function _callee(f) {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (f()) {
              _context.next = 5;
              break;
            }

            _context.next = 3;
            return sleep(200);

          case 3:
            _context.next = 0;
            break;

          case 5:
            return _context.abrupt("return", f());

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function waitFor(_x) {
    return _ref.apply(this, arguments);
  };
}();

var inIframe = function inIframe() {
  if (typeof window !== 'undefined') {
    return window !== window.parent;
  }

  if ((typeof global === "undefined" ? "undefined" : _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(global)) === 'object') {
    if ( true && global.mgnlInPageEditor === undefined) {
      // eslint-disable-next-line no-console
      console.log('For SSR, please set \'global.mgnlInPageEditor\' to true when you need to render edit bars, and false when not.');
    }

    return Boolean(global.mgnlInPageEditor);
  }

  return false;
};
var inPreviewAsVisitor = function inPreviewAsVisitor() {
  if (typeof window === 'undefined') {
    return (typeof global === "undefined" ? "undefined" : _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(global)) === 'object' ? global.mgnlPreviewAsVisitor : false;
  }

  return inIframe() && new URLSearchParams(window.location.search).get('mgnlPreviewAsVisitor') === 'true';
};
/**
 * @deprecated Since version 1.1.0. Use inEditorAsync instead.
 */

var inEditor = function inEditor() {
  return inIframe() && context.serverUrl.endsWith(':edit');
};
var inEditorAsync = /*#__PURE__*/function () {
  var _ref2 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.mark(function _callee2() {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.t0 = inIframe();

            if (!_context2.t0) {
              _context2.next = 5;
              break;
            }

            _context2.next = 4;
            return waitFor(function () {
              return context.serverUrl.length > 0;
            });

          case 4:
            _context2.t0 = _context2.sent;

          case 5:
            if (!_context2.t0) {
              _context2.next = 7;
              break;
            }

            return _context2.abrupt("return", context.serverUrl.endsWith(':edit'));

          case 7:
            return _context2.abrupt("return", false);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function inEditorAsync() {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * @deprecated Since version 1.1.0. Use inEditorAsync instead.
 */

var inEditorPreview = function inEditorPreview() {
  return inIframe() && context.serverUrl.endsWith(':view');
};
/**
 * @deprecated Since version 1.1.0. Use inEditorAsync instead.
 */

var isRenderingAnnotation = function isRenderingAnnotation() {
  return inIframe() && (inEditor() || !context.serverUrl);
};
var refresh = function refresh() {
  var windowInstance = getWindowInstance();

  if (inIframe() && windowInstance.mgnlRefresh) {
    if (document.documentElement.innerHTML.indexOf('<!--cms:page') > -1) {
      windowInstance.mgnlRefresh();
    } else {
      setTimeout(refresh, 200);
    }
  }
};
var onFrameReady = function onFrameReady() {
  var windowInstance = getWindowInstance();

  if (inIframe() && windowInstance.mgnlFrameReady) {
    windowInstance.mgnlFrameReady();
  }
};
var setServerUrl = function setServerUrl(url) {
  context.serverUrl = url;
};
/* harmony default export */ __webpack_exports__["default"] = ({
  inEditor: inEditor,
  inEditorAsync: inEditorAsync,
  inEditorPreview: inEditorPreview,
  inIframe: inIframe,
  isRenderingAnnotation: isRenderingAnnotation,
  isSameOrigin: isSameOrigin,
  refresh: refresh,
  setServerUrl: setServerUrl,
  onFrameReady: onFrameReady,
  inPreviewAsVisitor: inPreviewAsVisitor
});
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../node_modules/webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./src/service/LoggerService.js":
/*!**************************************!*\
  !*** ./src/service/LoggerService.js ***!
  \**************************************/
/*! exports provided: log, info, warn, error, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "log", function() { return log; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "info", function() { return info; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "warn", function() { return warn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "error", function() { return error; });
function exec() {
  var fnName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'log';
  var message = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof console === 'undefined') {
    return;
  } // eslint-disable-next-line no-console


  for (var _len = arguments.length, optionalParams = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    optionalParams[_key - 2] = arguments[_key];
  }

  console[fnName](message, optionalParams);
}

var log = function log(message) {
  for (var _len2 = arguments.length, optionalParams = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    optionalParams[_key2 - 1] = arguments[_key2];
  }

  exec('log', message, optionalParams);
};
var info = function info(message) {
  for (var _len3 = arguments.length, optionalParams = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    optionalParams[_key3 - 1] = arguments[_key3];
  }

  exec('info', message, optionalParams);
};
var warn = function warn(message) {
  for (var _len4 = arguments.length, optionalParams = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    optionalParams[_key4 - 1] = arguments[_key4];
  }

  exec('warn', message, optionalParams);
};
var error = function error(message) {
  for (var _len5 = arguments.length, optionalParams = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    optionalParams[_key5 - 1] = arguments[_key5];
  }

  exec('error', message, optionalParams);
};
/* harmony default export */ __webpack_exports__["default"] = ({
  log: log,
  info: info,
  warn: warn,
  error: error
});

/***/ }),

/***/ "./src/service/PageEditorBridge.js":
/*!*****************************************!*\
  !*** ./src/service/PageEditorBridge.js ***!
  \*****************************************/
/*! exports provided: onMessage, getBaseServerUrl, requestServerUrl, init, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onMessage", function() { return onMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBaseServerUrl", function() { return getBaseServerUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "requestServerUrl", function() { return requestServerUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "init", function() { return init; });
/* harmony import */ var _EditorContextHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./EditorContextHelper */ "./src/service/EditorContextHelper.js");

var listeners = {};
var onMessage = function onMessage(action, callback) {
  if (!action || typeof callback !== 'function') {
    return;
  }

  var actionLowerCase = action.toLowerCase();
  listeners[actionLowerCase] = listeners[actionLowerCase] || [];
  listeners[actionLowerCase].push(callback);
};
function getBaseServerUrl(serverUrl) {
  var url = new URL(serverUrl);
  return "".concat(url.protocol, "//").concat(url.hostname).concat(url.port ? ":".concat(url.port) : '').concat(url.pathname.substring(0, url.pathname.indexOf('.magnolia')));
}

function getActionListeners(action) {
  if (!action) {
    return [];
  }

  return listeners[action.toLowerCase()] || [];
}

function registerPageEditor(callback, serverUrl) {
  var id = 'mgnlPageEditorBridge';
  var bridgeScript = document.getElementById(id);

  if (bridgeScript || !serverUrl) {
    if (typeof callback === 'function') {
      callback();
    }

    return;
  }

  var hostUrl = getBaseServerUrl(serverUrl);
  var firstScript = document.getElementsByTagName('script')[0];
  bridgeScript = document.createElement('script');
  bridgeScript.id = id;
  bridgeScript.src = "".concat(hostUrl, "VAADIN/widgetsets/info.magnolia.PageEditor/info.magnolia.PageEditor.nocache.js");
  firstScript.parentNode.insertBefore(bridgeScript, firstScript);

  bridgeScript.onload = function () {
    setTimeout(function () {
      _EditorContextHelper__WEBPACK_IMPORTED_MODULE_0__["default"].onFrameReady();
      _EditorContextHelper__WEBPACK_IMPORTED_MODULE_0__["default"].refresh();

      if (typeof callback === 'function') {
        callback();
      }
    }, 200);
  };

  var style = document.createElement('link');
  style.href = "".concat(hostUrl, "VAADIN/themes/pages-app/page-editor.css");
  style.type = 'text/css';
  style.rel = 'stylesheet';
  document.head.insertBefore(style, document.head.firstChild);
}

var requestServerUrl = function requestServerUrl() {
  var notifyMessage = {
    element: {
      dialog: '',
      path: '/',
      workspace: 'website'
    },
    action: 'initialize',
    elementType: 'page'
  };
  window.parent.postMessage(JSON.stringify(notifyMessage), '*');
};
var init = function init(callback) {
  if (_EditorContextHelper__WEBPACK_IMPORTED_MODULE_0__["default"].isSameOrigin()) {
    return;
  }

  window.addEventListener('message', function (event) {
    if (!event.data || !(typeof event.data === 'string' && event.data.startsWith('{'))) return;
    var message = JSON.parse(event.data);
    var actionListeners = getActionListeners(message.action);
    actionListeners.forEach(function (listener) {
      try {
        listener(message);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    });
  });
  onMessage('updateState', function (message) {
    var serverUrl = message.serverUrl;
    _EditorContextHelper__WEBPACK_IMPORTED_MODULE_0__["default"].setServerUrl(serverUrl);
    registerPageEditor(callback, serverUrl);
  });
  requestServerUrl();
};
/* harmony default export */ __webpack_exports__["default"] = ({
  init: init,
  onMessage: onMessage,
  requestServerUrl: requestServerUrl
});

/***/ }),

/***/ "./src/service/PersonalizationService.js":
/*!***********************************************!*\
  !*** ./src/service/PersonalizationService.js ***!
  \***********************************************/
/*! exports provided: getSelectedVariant, getVariant, wrap, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSelectedVariant", function() { return getSelectedVariant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getVariant", function() { return getVariant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wrap", function() { return wrap; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _EditorContextHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./EditorContextHelper */ "./src/service/EditorContextHelper.js");



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


var getSelectedVariant = function getSelectedVariant(content, templateAnnotations) {
  if (!content || !templateAnnotations) {
    return content;
  }

  var annotations = templateAnnotations[content['@path']];
  var match = annotations ? annotations.match(/selectedVariant="(.+)"/) : null;
  if (!match) return content;
  var variant = match[1];
  return variant === content['@name'] ? content : content[variant];
};
var getVariant = function getVariant(content, templateAnnotations) {
  if (!_EditorContextHelper__WEBPACK_IMPORTED_MODULE_2__["default"].inIframe() || _EditorContextHelper__WEBPACK_IMPORTED_MODULE_2__["default"].inPreviewAsVisitor()) {
    return content;
  }

  return getSelectedVariant(content, templateAnnotations);
};
/**
 * Wrap template annotations in order to resolve personalized content.
 *
 * Search for 'selectedVariant' in the template annotations and try to replace the value
 * of the aforementioned attribute with selected one by the variant select.
 *
 * Server does not know which variant was selected, thus we store it in the client app session on
 * variant select change.
 */

var wrap = function wrap(templateAnnotations, selectedComponentVariants) {
  if (!selectedComponentVariants) {
    return templateAnnotations;
  }

  var modified = {};
  var selectedVariantRegex = /selectedVariant="(.+?)"/;
  Object.entries(templateAnnotations).forEach(function (entry) {
    var _entry = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default()(entry, 2),
        path = _entry[0],
        comment = _entry[1];

    if (selectedVariantRegex.test(comment) && path in selectedComponentVariants) {
      var selectedVariant = selectedComponentVariants[path]; // name of the 'original' variant has to be remapped to the node name
      // get it from the path

      if (selectedVariant === 'original') {
        selectedVariant = path.split('/').pop();
      }

      modified[path] = comment.replace(selectedVariantRegex, "selectedVariant=\"".concat(selectedVariant, "\""));
    }
  }); // merge the template annotations with modified annotations

  return _objectSpread(_objectSpread({}, templateAnnotations), modified);
};
/* harmony default export */ __webpack_exports__["default"] = ({
  getVariant: getVariant,
  wrap: wrap
});

/***/ }),

/***/ "./src/service/TemplateAnnotations.js":
/*!********************************************!*\
  !*** ./src/service/TemplateAnnotations.js ***!
  \********************************************/
/*! exports provided: getPageCommentString, getAreaCommentString, getComponentCommentString, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPageCommentString", function() { return getPageCommentString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAreaCommentString", function() { return getAreaCommentString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getComponentCommentString", function() { return getComponentCommentString; });
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__);


var ACTIVATION_STATUS_NOT_ACTIVATED = 0;
var ACTIVATION_STATUS_MODIFIED = 1;
var ACTIVATION_STATUS_ACTIVATED = 2;
var VALUE_PROCESSORS = {
  content: getContentPath,
  availableComponents: getAvailableComponents,
  showAddButton: canAddMoreComponents,
  activationStatus: getActivationStatus
};
var PAGE_MAP = {
  content: ['@path', ''],
  dialog: ['dialog', '', getValueFromObject]
};
var AREA_MAP = {
  name: ['@name', ''],
  content: PAGE_MAP.content,
  dialog: PAGE_MAP.dialog,
  availableComponents: ['availableComponents', []],
  type: ['type', 'list', getValueFromObject],
  label: ['title', '', getValueFromObject],
  inherit: ['inheritance', false, getValueFromObject],
  optional: ['optional', false, getValueFromObject],
  createdAreaNode: ['createAreaNode', true, getValueFromObject],
  showAddButton: ['maxComponents', true],
  showNewComponentArea: [null, true],
  description: ['description', '', getValueFromObject],
  activationStatus: [null, 0]
};
var COMPONENT_MAP = {
  content: PAGE_MAP.content,
  dialog: PAGE_MAP.dialog,
  label: ['title', '', getValueFromObject],
  description: ['description', '', getValueFromObject],
  activationStatus: [null, 0]
};

function getCommentString(data, map, templateDefinition, customParams) {
  var result = [];
  Object.keys(map).forEach(function (key) {
    var _map$key = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default()(map[key], 3),
        dataKey = _map$key[0],
        defaultValue = _map$key[1],
        getDataFn = _map$key[2];

    var contentProcessor = VALUE_PROCESSORS[key];
    var value = defaultValue;

    if (contentProcessor) {
      value = contentProcessor(data, dataKey, templateDefinition, customParams);
    } else if (getDataFn) {
      value = getDataFn(templateDefinition, dataKey, defaultValue);
    } else if (data != null && dataKey !== null) {
      value = data[dataKey] || '';
    }

    var item = {
      key: key,
      value: value
    };

    if (typeof item.value !== 'string' || item.value) {
      result.push("".concat(key, "=\"").concat(item.value, "\""));
    }
  });
  return result.join(' ');
}

function getAvailableComponents(area, dataKey, templateDefinition) {
  if (!templateDefinition || !templateDefinition[dataKey]) {
    return '';
  }

  return Object.keys(templateDefinition[dataKey]).map(function (key) {
    return templateDefinition[dataKey][key].id;
  }).join(',');
}

function canAddMoreComponents(area, dataKey, templateDefinition, customParams) {
  if (!templateDefinition || templateDefinition.maxComponents == null || !customParams || customParams.componentCount == null) {
    return true;
  }

  return customParams.componentCount < templateDefinition.maxComponents;
}

function getValueFromObject(obj, key, defaultValue) {
  var value = obj && _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(obj) === 'object' && key ? obj[key] : null;
  value = value == null ? defaultValue : value;
  value = typeof defaultValue === 'boolean' ? Boolean(value) : value;
  return value != null ? value : defaultValue;
}

function getContentPath(data, key) {
  var value = data ? data[key] : null; // NOTE: Empty string is acceptable. So we need check value != null

  return value != null ? "website:".concat(value) : '';
}

function generateMissingAreas(content, templateAnnotations) {
  if (!content || !templateAnnotations) {
    return content;
  }

  var decoratedContent = JSON.parse(JSON.stringify(content));
  Object.keys(templateAnnotations).forEach(function (key) {
    if (key.includes(content['@path']) && templateAnnotations[key].startsWith('cms:area')) {
      var areaName = key.split('/').pop();

      if (!(areaName in content)) {
        decoratedContent[areaName] = {
          '@path': "".concat(content['@path'], "/").concat(areaName),
          '@nodes': [],
          '@id': "".concat(content['@path'], "/").concat(areaName)
        };
      }
    }
  });
  return decoratedContent;
}

function getActivationStatus(data) {
  if (!data || !data['mgnl:activationStatus'] || data['mgnl:activationStatus'] === 'false') {
    return ACTIVATION_STATUS_NOT_ACTIVATED;
  }

  var lastModified = data['mgnl:lastModified'] ? new Date(data['mgnl:lastModified']) : null;
  var lastActivated = data['mgnl:lastActivated'] ? new Date(data['mgnl:lastActivated']) : null;
  return lastModified && lastActivated && lastModified.getTime() > lastActivated.getTime() ? ACTIVATION_STATUS_MODIFIED : ACTIVATION_STATUS_ACTIVATED;
}

var getPageCommentString = function getPageCommentString(page, templateDefinition) {
  return "cms:page ".concat(getCommentString(page, PAGE_MAP, templateDefinition));
};
var getAreaCommentString = function getAreaCommentString(area, templateDefinition, componentCount) {
  var customParams = {
    componentCount: componentCount
  };
  var areaTemplateDefinition = templateDefinition && templateDefinition.areas ? templateDefinition.areas[area['@name']] : {};
  return "cms:area ".concat(getCommentString(area, AREA_MAP, areaTemplateDefinition, customParams));
};
var getComponentCommentString = function getComponentCommentString(component, templateDefinition) {
  return "cms:component ".concat(getCommentString(component, COMPONENT_MAP, templateDefinition));
};
/* harmony default export */ __webpack_exports__["default"] = ({
  getAreaCommentString: getAreaCommentString,
  getComponentCommentString: getComponentCommentString,
  getPageCommentString: getPageCommentString,
  generateMissingAreas: generateMissingAreas
});

/***/ }),

/***/ "./src/service/index.js":
/*!******************************!*\
  !*** ./src/service/index.js ***!
  \******************************/
/*! exports provided: TemplateAnnotations, EditorContextHelper, LoggerService, PersonalizationService, PageEditorBridge */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _TemplateAnnotations__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TemplateAnnotations */ "./src/service/TemplateAnnotations.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TemplateAnnotations", function() { return _TemplateAnnotations__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _EditorContextHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./EditorContextHelper */ "./src/service/EditorContextHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EditorContextHelper", function() { return _EditorContextHelper__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _LoggerService__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./LoggerService */ "./src/service/LoggerService.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LoggerService", function() { return _LoggerService__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony import */ var _PersonalizationService__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./PersonalizationService */ "./src/service/PersonalizationService.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PersonalizationService", function() { return _PersonalizationService__WEBPACK_IMPORTED_MODULE_3__["default"]; });

/* harmony import */ var _PageEditorBridge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./PageEditorBridge */ "./src/service/PageEditorBridge.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PageEditorBridge", function() { return _PageEditorBridge__WEBPACK_IMPORTED_MODULE_4__["default"]; });







/***/ }),

/***/ 0:
/*!****************************!*\
  !*** multi ./src/index.js ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! ./src/index.js */"./src/index.js");


/***/ })

/******/ });
});
